/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {library} from '@fortawesome/fontawesome-svg-core'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {
  faArrowLeft,
  faArrowRight,
  faAtom,
  faBan,
  faBars,
  faBook,
  faCalendar,
  faChartPie,
  faCheckCircle,
  faChessKnight,
  faClock,
  faCloud,
  faCog,
  faComment,
  faDiceSix,
  faEllipsisH,
  faExclamationTriangle,
  faFilm,
  faFingerprint,
  faFistRaised,
  faGamepad,
  faGraduationCap,
  faHome,
  faLock,
  faMeh,
  faMinus,
  faPaperPlane,
  faPenAlt,
  faPlus,
  faPoo,
  faPuzzlePiece,
  faQuestionCircle,
  faReceipt,
  faShieldAlt,
  faShoppingCart,
  faSignOutAlt,
  faStore,
  faTachometerAlt,
  faTimes,
  faTrash,
  faTrophy,
  faUnlockAlt,
  faUserCircle,
  faUserFriends,
  faWallet,
  faWindowMaximize,
  faWindowRestore,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  fab,
  faArrowLeft,
  faArrowRight,
  faAtom,
  faBan,
  faBars,
  faBook,
  faCalendar,
  faChartPie,
  faCheckCircle,
  faChessKnight,
  faClock,
  faCloud,
  faCog,
  faComment,
  faDiceSix,
  faEllipsisH,
  faExclamationTriangle,
  faFilm,
  faFingerprint,
  faFistRaised,
  faGraduationCap,
  faGamepad,
  faHome,
  faLock,
  faMeh,
  faMinus,
  faPaperPlane,
  faPenAlt,
  faPlus,
  faPoo,
  faPuzzlePiece,
  faQuestionCircle,
  faReceipt,
  faShieldAlt,
  faShoppingCart,
  faSignOutAlt,
  faStore,
  faTachometerAlt,
  faTimes,
  faTrash,
  faTrophy,
  faUnlockAlt,
  faUserCircle,
  faUserFriends,
  faWallet,
  faWindowMaximize,
  faWindowRestore,
)
